import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OopbuySpreadsheetGuide from "../pages/blog/OopbuySpreadsheetGuide";
import WhatIsOopbuySpreadsheet from "../pages/blog/WhatIsOopbuySpreadsheet";
import OopbuyVsTraditional from "../pages/blog/OopbuyVsTraditional";
import HowSpreadsheetAgentsWork from "../pages/blog/HowSpreadsheetAgentsWork";
import SpreadsheetShoppingSafe from "../pages/blog/SpreadsheetShoppingSafe";
import SpreadsheetShoppingTips from "../pages/blog/SpreadsheetShoppingTips";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuySpreadsheetGuide />,
  },
  {
    path: "/blog/what-is-oopbuy-spreadsheet",
    element: <WhatIsOopbuySpreadsheet />,
  },
  {
    path: "/blog/oopbuy-vs-traditional-agents",
    element: <OopbuyVsTraditional />,
  },
  {
    path: "/blog/how-spreadsheet-agents-work",
    element: <HowSpreadsheetAgentsWork />,
  },
  {
    path: "/blog/is-spreadsheet-shopping-safe",
    element: <SpreadsheetShoppingSafe />,
  },
  {
    path: "/blog/spreadsheet-shopping-tips",
    element: <SpreadsheetShoppingTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;